module.exports = __webpack_public_path__ + "b4h.png?1f74e34dc54c1b39c9d2b17ca16df064";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/charity/b4h.png
// module id = 1069
// module chunks = 2